import Typography from '@/app/components/typography'
import { cn } from '@/util/cn'
import ChevronLeftIcon from '@/components/icons/chevron-left-icon'
import ChevronRightIcon from '@/components/icons/chevron-right-icon'

type Props = {
    isDisabled: boolean
    onPrev: () => void
    onNext: () => void
}

const buttonClassName = cn('flex cursor-pointer flex-row items-center gap-3')

const SlideDesktopNavigation = ({ isDisabled, onPrev, onNext }: Props) => (
    <div className="absolute bottom-6 mt-auto flex w-full items-center justify-between px-10">
        <button className={buttonClassName} onClick={onPrev} disabled={isDisabled}>
            <ChevronLeftIcon className="size-[0.8rem]" />

            <Typography fontWeight="bold" variant="text-lg" className="opacity-75">
                Prev
            </Typography>
        </button>

        <button className={buttonClassName} onClick={onNext} disabled={isDisabled}>
            <Typography fontWeight="bold" variant="text-lg" className="opacity-75">
                Next
            </Typography>

            <ChevronRightIcon className="size-[0.8rem]" />
        </button>
    </div>
)

export default SlideDesktopNavigation
